import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/customerGroups'
import Component from 'components/CustomerGroups'

export default createListViewContainer({ actions, selectors: selectors.customerGroups })(Component)
